"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deriveCustomTypeInstance_1 = require("./deriveCustomTypeInstance");
var deepClone = function (target, src, shallow, isClientSide) {
    if (shallow === void 0) { shallow = false; }
    if (isClientSide === void 0) { isClientSide = typeof window !== 'undefined'; }
    for (var key in src) {
        var value = src[key];
        var descriptor = Object.getOwnPropertyDescriptor(src, key) ||
            Object.getOwnPropertyDescriptor(Object.getPrototypeOf(src), key);
        if (descriptor && typeof descriptor.get === 'function')
            continue;
        if (!shallow &&
            value &&
            typeof value === 'object' &&
            (!isClientSide || !(value instanceof Node))) {
            var targetObj = target[key]
                ? target[key]
                : (target[key] = deriveCustomTypeInstance_1.default(value));
            deepClone(targetObj, value, shallow, isClientSide);
        }
        else {
            target[key] = value;
        }
    }
    return target;
};
exports.default = deepClone;
//# sourceMappingURL=deepClone.js.map